import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import DashBoardAdmin from './pages/dashboardAdmin';
import DashBoardSales from './pages/dashboardSales';
import DashBoardLogistic from './pages/dashboardLogistic';
import DashBoardAccounts from './pages/dashboardAccounts';
import OrdersSales from './pages/ordersSales';
import OrdersLogistic from './pages/ordersLogistic';

import NoPage from './pages/noPage';
import AddEmp from './pages/addEmployees';
import AllEmp from './pages/viewEmployee';
import NewOrder from './pages/newOrder';
import NewClient from './pages/newClient';
import Login from './pages/login';
import AllClient from './pages/viewClients';
import AllOrders from './pages/viewOrders';
// import NewInv from './pages/newInvoice';
import Test from './pages/test';

import PaymentReceive from './pages/PaymentReceive';
import AddPaymentReceive from './pages/AddPaymentReceive';
import AddPaymentMade from './pages/addPaymentMade';
import PaymentMade from './pages/PaymentMade';
import AddExpense from './pages/addexpense';
import Expense from './pages/expense';
import PayRole from './pages/PayRole';
import AddPayRole from './pages/addPayRole';
import Product from './pages/product';
import AddProduct from './pages/addproduct';
import EditProduct from './pages/editproduct';
import Addcompany from './pages/addcompany';
import Addservice from './pages/addservice';
import Viewinvoice from './pages/viewinvoice';

import MyClients from './pages/myClients';
import MyReport from './pages/clientReport';
import OrderDetails from './pages/orderDetails';
import EmpReport from './pages/employeeReport';
import EditOrder from './pages/editOrder';

import AccOrders from './pages/sales';
import EditAccorders from './pages/editSales';
import ViewAccOrders from './pages/viewsales';
import Getinvoice from './pages/invoicepage';

import AddDealer from './pages/addDealer';
import ViewDealer from './pages/viewDealers';
import EditDealer from './pages/editDealer';
import DealerDetails from './pages/dealerDetails';
import DealerReport from './pages/admin/reportDealer';

import DailyInvoice from './pages/admin/dailyInvoice';
import Invoice from './pages/admin/invoices';
import InvoiceDetail from './pages/admin/invoiceDetails';
import DealerIncentive from './pages/admin/dealerIncentiveReport';

import InvReport from './pages/admin/monthlyinvoiceReport';
import StockReport from './pages/admin/stockReport';
import NewInvoices from './pages/admin/newInvoice';

import Crates from './pages/admin/crates';

import ViewSchedule from './pages/sales/view-client';
import ClientSchedule from './pages/sales/clientSchedule';
import AddSchedule from './pages/sales/add-schedule';
import ReportSchedule from './pages/sales/scheduleReport';
import ClientNewOrder from './pages/sales/client-order';

import ViewRoute from './pages/admin/viewRoute';
import NewRoute from './pages/admin/newRoute';

import RouteReport from './pages/monthlyInvoice';

import CratesReport from './pages/reports/cratesReport';
import DealerIncReports from './pages/reports/dealerIncentiveReport';
import MarketingReport from './pages/reports/marketing';
import MarketingDetailsReport from './pages/reports/marketing-details';
import MonthlyIncReport from './pages/reports/monthly-incentive';
import LedgerReport from './pages/reports/ledgerReport';
import DailyReport from './pages/reports/dailyReport';
import DailySalesReport from './pages/reports/dailySalesReport';

import Chellans from './pages/admin/chellans';
import ChellanReport from './pages/admin/chellanReport';
import ChellanDetails from './pages/admin/chellanDetails';

import RateBook from './pages/admin/rateBook';
import MonthlyIncentive from './pages/admin/monthlyIncentive';

import MonthlySales from './pages/reports/monthlySalesReport'

import WhatsApp from './pages/whatsApp';

import AddPurchase from './pages/addPurchase';
import Purchase from './pages/purchase';


import MasterLedgerReport from './pages/ledger/masterLedger';
import ReceivableLedgerReport from './pages/ledger/receivablesLedger';
import LiabilityLedgerReport from './pages/ledger/liabilityLedger';
import PurchaseLedgerReport from './pages/ledger/purchaseLedger';
import ExpenseLedgerReport from './pages/ledger/expensesLedger';
import PaymentReport from './pages/reports/paymentsReport';

import AllChellans from './pages/admin/newChellans';
import NewChellans from './pages/admin/createChellan';
import AddChellans from './pages/admin/challanCreate';

import DealerReports from './pages/reports/dealerReport';
import IndReports from './pages/reports/individualReport';

import DailyItems from './pages/reports/dailyItemReport';
import DailyOrders from './pages/reports/dailyOrderReport';
import DailyInvoiceReport from './pages/reports/dailyInvoiceReport';

import GstInvoice from './pages/reports/gstFileInvoice';

import Dispatch from './pages/reports/dispatch';
import RouteReportWise from './pages/reports/routeinvoice';

import UploadPayments from './pages/uploadPayment';

import PartyOutstand from './pages/ledger/partyOutstand';
import CdNoteAdd from './pages/ledger/cdNoteAdd';
import CdNoteView from './pages/ledger/creditNotes';
import BranchCollection from './pages/ledger/branchCollection';
import BranchCollected from './pages/ledger/branchCollected';
import PartyLedger from './pages/ledger/partyLedger';
import PartyLedgerView from './pages/ledger/partyLedgerView';
import AddLedgers from './pages/ledger/addLedgers';

import PriceUpdate from './pages/admin/priceUpdate';



function App() {

  // PWA install prompt state
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = (e) => {
      // console.log("beforeinstallprompt event fired");
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;

    console.log("Install choice:", result);

    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  // console.log(location.pathname);

  return (
    <>
      {/* Optional: PWA Install button */}
        {(location?.pathname === '/' || location?.pathname === '') &&  showInstallButton && (
          <div className="install-banner">
            <p>Install our app for a better experience!</p>
            <div className='button mt-2'>
              <button className='btn btn-primary' onClick={handleInstallClick}>Install App</button>
              <button className='btn btn-danger' onClick={() => setShowInstallButton(false)}>Cancel</button>
            </div>
          </div>
        )}
      <Routes>
        <Route path="*" element={<NoPage/>} />
        <Route path="/" element={<Login/>} />

        <Route path="/admin-dashboard" element={<DashBoardAdmin />} />
        <Route path="/sales-dashboard" element={<DashBoardSales />} />
        <Route path="/logistic-dashboard" element={<DashBoardLogistic />} />
        <Route path="/accounts-dashboard" element={<DashBoardAccounts />} />

        <Route path="/sales-orders" element={<OrdersSales />} />
        <Route path="/logistic-orders" element={<OrdersLogistic />} />
        <Route path="/new-order" element={<NewOrder />} />
        <Route path="/view-orders" element={<AllOrders />} />
        <Route path="/order-details" element={<OrderDetails />} />
        <Route path="/edit-order" element={<EditOrder />} />
        <Route path='/account-new-orders' element={<AccOrders/>}/>
        <Route path='/account-edit-orders' element={<EditAccorders/>}/>
        <Route path='/account-view-orders' element={<ViewAccOrders/>}/>

        <Route path="/new-employee" element={<AddEmp />} />
        <Route path="/view-employee" element={<AllEmp />} />
        <Route path="/employee-report" element={<EmpReport />} />

        

        <Route path="/new-client" element={<NewClient />} />
        <Route path="/view-clients" element={<AllClient />} />
        <Route path="/my-clients" element={<MyClients />} />
        <Route path="/clients-report" element={<MyReport />} />
       
        <Route path="/new-invoice" element={<NewInvoices />} />
        <Route path='/viewinvoice' element={<Viewinvoice/>}/>
        <Route path='/get-Invoice' element={<Getinvoice/>}/>

       
        <Route path="/test" element={<Test />} />

        <Route path='/payment-received' element={<PaymentReceive />} />
        <Route path='/AddPaymentReceive' element={<AddPaymentReceive />} />
        <Route path='/PaymentMade' element={<PaymentMade/>}/>
        <Route path='/addPaymentMade' element={<AddPaymentMade/>}/>
        <Route path='/payrole' element={<PayRole/>}/>
        <Route path='/AddPayRole' element={<AddPayRole/>}/>
        <Route path='/addexpense' element={<AddExpense/>}/>
        <Route path='/expense' element={<Expense/>}/>
        <Route path='/product' element={<Product/>}/>
        <Route path='/addproduct' element={<AddProduct/>}/>
        <Route path='/editproduct' element={<EditProduct/>}/>
        <Route path='/addcompany' element={<Addcompany/>}/>
        <Route path='/addservice' element={<Addservice/>}/>

        <Route path='/add-dealer' element={<AddDealer/>}/>
        <Route path='/view-dealer' element={<ViewDealer/>}/>
        <Route path='/edit-dealer' element={<EditDealer/>}/>
        <Route path='/dealer-details' element={<DealerDetails/>}/>
        <Route path='/report-dealer' element={<DealerReport/>}/>

        <Route path='/daily-invoice' element={<DailyInvoice/>}/>
        <Route path='/new-invoices' element={<NewInvoices/>}/>
        <Route path='/all-invoice' element={<Invoice/>}/>
        <Route path='/invoice-details' element={<InvoiceDetail/>}/>
        <Route path='/dealer-incentive' element={<DealerIncentive/>}/>

        <Route path='/report-sales' element={<InvReport/>}/>
        <Route path='/report-items' element={<StockReport/>}/>

        <Route path='/crates' element={<Crates />}/>
        <Route path='/crates-report' element={<CratesReport />}/>

        <Route path='/view-client-schedule' element={<ViewSchedule />}/>
        <Route path='/view-sechedule' element={<ClientSchedule />} />
        <Route path='/add-schedule' element={<AddSchedule />} />
        <Route path='/report-schedule' element={<ReportSchedule />}/>
        <Route path='/clients-schedule' element={<ClientSchedule />}/>
        <Route path='/client-neworder' element={<ClientNewOrder />}/>

        <Route path='/view-routes' element={<ViewRoute />}/>
        <Route path='/new-routes' element={<NewRoute />}/>
        <Route path='/route-report' element={<RouteReport />}/>

        <Route path='/dealer-incentives' element={<DealerIncReports />}/>
        <Route path='/sales-report' element={<MarketingReport />}/>
        <Route path='/sales-report-details' element={<MarketingDetailsReport />}/>
        <Route path='/monthly-incentive' element={<MonthlyIncReport />}/>
        <Route path='/ledger' element={<LedgerReport />}/>
        <Route path='/daily-report' element={<DailyReport />}/>
        <Route path='/daily-sales-report' element={<DailySalesReport />}/>

        <Route path='/view-chellans' element={<Chellans />}/>
        <Route path='/chellan-details' element={<ChellanDetails />}/>
        <Route path='/chellan-reports' element={<ChellanReport />}/>

        <Route path='/rate-book' element={<RateBook />}/>
        <Route path='/monthly-incentive-report' element={<MonthlyIncentive />}/>
        <Route path='/monthly-sales-report' element={<MonthlySales />}/>

        <Route path='/whatsapp' element={<WhatsApp />}/>
		
		    <Route path='/addpurchase' element={<AddPurchase />}/>
        <Route path='/view-purchase' element = {<Purchase/>}/>

        
        <Route path='/master-ledger' element={<MasterLedgerReport/>}/>
        <Route path='/expense-ledger' element={<ExpenseLedgerReport/>}/>
        <Route path='/purchase-ledger' element={<PurchaseLedgerReport/>}/>
        <Route path='/liability-ledger' element={<LiabilityLedgerReport/>}/>
        <Route path='/receivable-ledger' element={<ReceivableLedgerReport/>}/>
        <Route path='/payment-report' element = {<PaymentReport/>}/>

        <Route path='/new-challans' element={<AllChellans />}/>
        <Route path='/create-challans' element={<NewChellans />}/>
        <Route path='/add-challans' element={<AddChellans />}/>

        <Route path='/dealer-reports' element={<DealerReports />}/>
        <Route path='/dealer-reports-details' element={<IndReports />}/>
        
        <Route path='/daily-items' element={<DailyItems />}/>
        <Route path='/daily-orders' element={<DailyOrders />}/>
        <Route path='/daily-invoice-report' element={<DailyInvoiceReport />}/>
        <Route path='/route-wise-report' element={<RouteReportWise />}/>

        <Route path='/tally-export' element={<GstInvoice />}/>

        <Route path='/dispatch' element={<Dispatch />}/>
        <Route path='/upload-payments' element={<UploadPayments />}/>
        <Route path='/party-outstand' element={<PartyOutstand />}/>
        <Route path='/cd-note-add' element={<CdNoteAdd />}/>
        <Route path='/cd-note-view' element={<CdNoteView />}/>
        <Route path='/branch-collection' element={<BranchCollection />}/>
        <Route path='/branch-collected' element={<BranchCollected />}/>
        <Route path='/party-ledger' element={<PartyLedger />}/>
        <Route path='/party-ledger-view' element={<PartyLedgerView />}/>
        <Route path='/add-ledgers' element={<AddLedgers />}/>

        <Route path='/price-update' element={<PriceUpdate />}/>

      </Routes>
    </>
);
}

export default App;